
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/schedule/event4",
      function () {
        return require("private-next-pages/schedule/event4/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/schedule/event4"])
      });
    }
  